export default __webpack_public_path__ + "static/image-cash-exchange-service-main-v3-960x540.png";